<!--  抽卡结果-->
<template>
  <div class="drawCard" v-show="show">
    <div class="box">
      <div class="btn">
        <button class="continue" @click="drawCard" v-if="activityUserInfo.remainingTimes">
          继续抽卡
          <p>（{{activityUserInfo.remainingTimes}}次）</p>
        </button>
      </div>
      <div class="close" @click="changeShow"></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
    };
  },
  props:{
    activityUserInfo:{
      type:Object,
      default:()=>{}
    }
  },
  computed: {},
  watch: {},
  methods: {
    changeShow() {
      this.show = !this.show;
    },
    drawCard(){
      this.changeShow()
      this.$emit('continueLottry');
    }
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.drawCard {
  position: fixed;
  top: 0;
  left: 0;
   z-index: 10;
  width: 100%;
  height: 100%;
  padding: 144px 116px 0 116px;
  background: rgba($color: #000, $alpha: 0.8);
  .box {
    width: 100%;
    min-height: 624px;
    padding-top: 624px;
    background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/lottery-res1.png')
      no-repeat;
    background-size: 100%;
    //  animation: flip 4s infinite linear;
    .btn {
      display: flex;
      justify-content: space-around;
      margin: 36px auto 40px;

      button {
        display: block;
        width: 250px;
        height: 80px;
        color: #fff;
        font-weight: 500;
        font-size: 32px;
        border-radius: 40px;
      }
      .accept {
        line-height: 80px;
        background: linear-gradient(180deg, #f86e77 0%, #ff2d5d 100%);
      }
      .continue {
        background: linear-gradient(180deg, #ffd64e 0%, #ff9c1c 100%);
        p {
          color: #fff;
          font-weight: 400;
          font-size: 22px;
          line-height: 30px;
          text-align: center;
        }
      }
    }
    .close {
      width: 66px;
      height: 66px;
      margin: 0 auto;
      background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/collectCard/close.png');
      background-size: 100%;
    }
  }
}
  @keyframes flip {
    0% {
      transform: perspective(1000px) rotateY(0deg);
    }
     33% {
      transform: perspective(1000px) rotateY(30deg);
    }
     66% {
      transform: perspective(1000px) rotateY(-30deg);
    }
     100% {
      transform: perspective(1000px) rotateY(0deg);
    }

  }
</style>
